import { getUrlMetaDirectS3VideoSource, getUrlMetaVideoSource, isVideoLikeMediaType } from './url-meta-media';

// Keep every slide in source order, including videos without a poster.
export const buildWorkspaceMediaGallery = (slides, { originalUrl = '', title = '' } = {}) => (
    (Array.isArray(slides) ? slides : []).filter(slide => slide && typeof slide === 'object' && Object.keys(slide).length).map((slide, index) => {
        const media = slide.media;
        const types = [slide.type, slide.media_type, media?.type, media?.mime, media?.format];
        const isImage = types.some(type => /^image(?:\/|$)/i.test(String(type || '')));
        const isVideo = types.some(isVideoLikeMediaType) || !isImage && (
            Boolean(getUrlMetaVideoSource(slide)) ||
            isVideoLikeMediaType(String(media?.url || '').split(/[?#]/)[0].split('.').pop())
        );
        const videoMeta = {
            ...slide,
            media_url: slide.media_url || media?.url,
            media_cdn_url: slide.media_cdn_url || media?.cdn_url
        };
        const poster = slide.image || (!isVideo ? media?.cdn_url || media?.url : '') || '';
        return {
            type: isVideo ? 'video' : 'image',
            src: isVideo ? getUrlMetaVideoSource(videoMeta) || '' : poster,
            hlsUrl: isVideo && !getUrlMetaDirectS3VideoSource(videoMeta) ? slide.media_hls_url || '' : '',
            image: poster,
            url: isVideo ? '' : poster,
            cdn_url: isVideo ? '' : poster,
            originalUrl,
            ...(slide.image_name ? { image_name: slide.image_name } : {}),
            ...(media ? { media } : {}),
            displayName: `${title || 'Image'} ${index + 1}`,
            ocrText: isVideo ? '' : media?.ocrText || slide.ocrText || ''
        };
    })
);

export const getWorkspaceGalleryIndex = (index, length) => {
    const requested = Number(index);
    return Math.max(0, Math.min(Number.isInteger(requested) ? requested : 0, Math.max(0, length - 1)));
};
